// @ts-nocheck

import { use, useEffect, useState } from "react";
import { db } from "../../db/db";
import { useLiveQuery } from "dexie-react-hooks";
import DebugLog from "../DebugLog";

import { API_BASE_URL as publicApiUrl } from "../../utils/api";

function ActivitySend({id}) {
  const activities = useLiveQuery(async () => {
    return await db.activities.where("postedSuccessfully").equals(0).toArray();
  });
  const [log, setLog] = useState();

  useEffect(() => {
    if (activities?.length > 0) {
      activities.map((activity) => {
        // A fix for activities that didn't store the session ID correctly. Should be redundant after a week or so (1/9/25)
        if (!activity.hasOwnProperty("type")) {
          console.table(activity);
        }
        const body = new URLSearchParams({
          save_new_record: "true",
          c: "ltgb2qzc31qn88xor",
          t: "l2_record_a_log",
          rdpartyintid_3: activity["id"],
          for_client_1: activity["clientId"],
          details_9: activity["details"],
          logged_by_7: id && id["id"],
          hc_visit_6: activity["type"] == "HC" ? activity["visitId"] : "",
          sl_session_6: activity["type"] == "SL" ? activity["visitId"] : "",
          com_out_0: activity["type"] == "Com Out" ? activity["visitId"] : "",
          date_logged_1: activity["id"],
        }).toString();
        setLog(`Sending: ${body}`);

        fetch(`${publicApiUrl}/activity`, {
          body: body,
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
          .then((res) => res.json())
          .then((json) => setLog(`Success: ${JSON.stringify(json)}`))
          .then(() => {
            db.activities.update(activity["id"], {
              postedSuccessfully: 1,
            });
          })
          .catch((error) => {
            console.log(error);
            setLog(`Error: ${error}`)
          });
      });
    }
  }, [activities]);

  return <DebugLog log={log} />;

}

export default ActivitySend;
